import 'slick-carousel'

export default class Featured {
  constructor() {
    this.el = $('.js-featured');

    if (!this.el.length) {
      return false;
    }

    this.el.find('.js-slick').slick({
      dots: false,
      infinite: true,
      speed: 450,
      slidesToShow: 1,
      variableWidth: true,
      draggable: true,
      arrows: false,
      cssEase: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)'
    });

    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);

    this.el.find('.js-prev').bind('click', this.onPrev);
    this.el.find('.js-next').bind('click', this.onNext);
  }

  onPrev() {
    this.el.find('.js-slick').slick('slickPrev');
  }

  onNext() {
    this.el.find('.js-slick').slick('slickNext');
  }
}
